import request from '@/utils/request'

export const getStageReview = (classId, stage) => request({
  url: `/classes/${classId}/stage-review`,
  method: 'get',
  params: { ...(stage != null ? { stage } : {}), _t: Date.now() }
})

// 获取班级列表
export const getClasses = (params) => {
  return request({
    url: '/classes',
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    params
  })
}

// 获取班级详情
export function getClass(id) {
  return request({
    url: `/classes/${id}`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

// 创建班级
export function createClass(data) {
  return request({
    url: '/classes',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: {
      ...data,
      // 如果使用模板排课,添加templateId
      ...(data.templateId ? { templateId: data.templateId } : {}),
      // 如果使用日历排课,添加sessions
      ...(data.sessions ? { sessions: data.sessions } : {})
    }
  })
}

// 更新班级
export function updateClass(id, data) {
  console.log('更新data', data)
  return request({
    url: `/classes/${id}`,
    method: 'patch',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data
  })
}

// 删除班级
export function deleteClass(id) {
  return request({
    url: `/classes/${id}`,
    method: 'delete',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

// 批量删除班级
export function batchDeleteClasses(classIds) {
  return request({
    url: '/classes/batch/delete',
    method: 'post',
    data: { classIds },
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

// 批量结课
export function batchCompleteClasses(classIds) {
  return request({
    url: '/classes/batch/complete',
    method: 'post',
    data: { classIds },
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

// 添加学员到班级
export const addStudentToClass = (classId, data) => {
  return request({
    url: `/classes/${classId}/students`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data
  })
}

// 获取班级学员列表
export function getClassStudents(classId) {
  if (!classId) {
    console.error('getClassStudents: 缺少班级ID')
    return Promise.reject(new Error('缺少班级ID'))
  }

  return request({
    url: `/classes/${classId}/students`,
    method: 'get',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

// 按选定字段导出当前班级的全部学员
export function exportClassStudents(classId, fields) {
  return request({
    url: `/classes/${classId}/students/export`,
    method: 'post',
    data: { fields },
    responseType: 'blob',
    headers: {
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}

export function getClassSeating(classId) {
  return request({
    url: `/classes/${classId}/seating`,
    method: 'get'
  })
}

export function saveClassSeating(classId, seating) {
  return request({
    url: `/classes/${classId}/seating`,
    method: 'put',
    data: seating
  })
}

// 同步排课模板
export function syncScheduleTemplate(classId) {
  return request({
    url: `/classes/${classId}/sync-template`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

// 根据模板ID同步所有使用该模板的班级
export function syncTemplateToAllClasses(templateId) {
  return request({
    url: `/classes/sync-template/${templateId}/all`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

// 同步班级学员到课节
export function syncStudentsToSessions(classId) {
  return request({
    url: `/classes/${classId}/sync-students`,
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    }
  })
}

// 学生转班
export const transferStudent = (data) => {
  return request({
    url: '/classes/transfer',
    method: 'post',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`
    },
    data: {
      ...data,
      ignoreClassType: Boolean(data?.ignoreClassType)
    }
  })
}

// 下载班级导入模板
export function downloadClassTemplate() {
  return request({
    url: '/classes/template/download',
    method: 'get',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}

// 批量导入班级
export function batchImportClasses(file) {
  const formData = new FormData()
  formData.append('file', file)
  
  return request({
    url: '/classes/batch/import',
    method: 'post',
    data: formData,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 下载班级导入错误报告
export function downloadClassImportErrorReport(reportPath) {
  return request({
    url: reportPath,
    method: 'get',
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${localStorage.getItem('token')}`,
      Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  })
}

// 班级结课
export function completeClass(id, data) {
  return request({
    url: `/classes/${id}/complete`,
    method: 'post',
    data
  })
}

// 取消班级结课
export function uncompleteClass(id) {
  return request({
    url: `/classes/${id}/uncomplete`,
    method: 'post'
  })
}

// 班级续报
export function continueEnrollment(classId, data) {
  return request({
    url: `/classes/${classId}/continue-enrollment`,
    method: 'post',
    data: {
      enrollments: data
    }
  })
}

// 新建续报班（单个）
export function createRenewalClass(id, data = {}) {
  return request({
    url: `/classes/${id}/create-renewal`,
    method: 'post',
    data
  })
}


// 修改班级排课
export function rescheduleClass(id, data) {
  return request({
    url: `/classes/${id}/reschedule`,
    method: 'post',
    data
  })
}

// 获取学习报告所需课程配置（课前测/例题/练习题数量 + 子小题数）
// _t 时间戳绕过 iOS WebKit 对无 Cache-Control 的 GET 的会话内存缓存，
// 否则切换课时后重复请求同一 URL 会返回旧配置，需退出重进才刷新
export function getLessonMeta(classId, lessonIndex) {
  return request({
    url: `/classes/${classId}/lesson-meta`,
    method: 'get',
    params: {
      ...(lessonIndex != null ? { lessonIndex } : {}),
      _t: Date.now()
    }
  })
}

// 检查教师/教室可用性
export function checkAvailability(data) {
  return request({
    url: '/classes/check-availability',
    method: 'post',
    data
  })
}

// 批量新建续报班
export function batchCreateRenewalClass(data) {
  return request({
    url: '/classes/batch/create-renewal',
    method: 'post',
    data
  })
}
 

export const removeClassStudent = (classId, studentId) => request({
  url: `/classes/${classId}/students/${studentId}/remove`,
  method: 'post'
})

export const assignClassStudent = (enrollmentId, classId) => request({
  url: `/classes/enrollments/${enrollmentId}/assign`,
  method: 'post',
  data: { classId }
})
